import PropertyDetails from "@/components/PropertyDetails";
import React from "react";
import { EnergyLabelRange, formatEnergyLabelRange } from "../EnergyLabel";

interface EnergyLabelDetailsProps {
  label: string;
  energyLabel: string;
  energyLabelBest?: string;
  energyLabelWorst?: string;
  info?: string;
}

const EnergyLabelDetails: React.FC<EnergyLabelDetailsProps> = ({
  label,
  energyLabel,
  energyLabelBest,
  energyLabelWorst,
}) => {
  return (
    <PropertyDetails
      label={label}
      value={formatEnergyLabelRange(
        energyLabel,
        energyLabelBest,
        energyLabelWorst,
      )}
      showUnit={false}
    >
      <EnergyLabelRange
        energyLabel={energyLabel}
        energyLabelBest={energyLabelBest}
        energyLabelWorst={energyLabelWorst}
      />
    </PropertyDetails>
  );
};

export default EnergyLabelDetails;
